<!-- eslint-disable -->
<template>
    <div>
        <div v-if="load" class="text-center mb-10">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
        <div v-else class="row">
            <div  class="col-12">
                <div class="card card-custom gutter-b">
                    <div  class="card-body">
                        <h3 class="card-title font-weight-bolder text-dark">Изображения товара</h3>
                        <b-alert v-if="errors.images" show variant="danger">{{errors.images[0]}}</b-alert>
                        <b-container fluid class="p-4 mb-3 bg-dark">
                            <ul class="ui-sortable">
                                <draggable :list="product.images" v-bind="{animation:400}">
                                    <li v-bind:key="i" class="image" v-for="(pr, i) in product.images" >
                                        <b-img  thumbnail fluid :src="$urlBackEnd(pr.thumbnail)" alt="Image 1"></b-img>
                                        <i @click="removeImage(pr.image_id)" class="fas fa-trash-alt"></i>
                                    </li>
                                </draggable>
                            </ul>
                        </b-container>
                        <vue-dropzone ref="myVueDropzone"
                                      id="dropzone"
                                      :options="dropzoneOptions"
                                      :useCustomSlot=true
                                      v-on:vdropzone-success="successDrop"
                                      v-on:vdropzone-max-files-exceeded="maxDrop"
                        >
                            <div class="dropzone-custom-content">
                                <b class="dropzone-custom-title">Выберите файлы</b>
                                <div class="subtitle">...или перетащите их сюда</div>
                            </div>
                        </vue-dropzone>



                        <h3 class="card-title mt-5 font-weight-bolder text-dark">Данные товара</h3>

                        <div class="form-group row mb-0">
                            <b-form-group class="col-lg-6 mb-2" description="Введите заголовок товара" label="Заголовок:">
                                <b-form-input v-model.trim="product.title" :class="{'is-invalid': errors.title}"></b-form-input>
                                <div v-if="errors.title" class="invalid-feedback">{{errors.title[0]}}</div>
                            </b-form-group>

                            <b-form-group class="col-lg-6 mb-2" description="Введите url товара или нажмите кнопку *Сформировать" label="url товара:">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <button @click="getCode" v-b-tooltip.hover title="Сформировать url адрес страницы товара на основе заголовка" ref="get_product_url" class="btn btn-primary" type="button">Сформировать</button>
                                    </div>
                                    <b-form-input v-model.trim="product.code" :class="{'is-invalid': errors.code}"></b-form-input>
                                    <div v-if="errors.code" class="invalid-feedback">{{errors.code[0]}}</div>
                                </div>
                            </b-form-group>
                        </div>

                        <b-card>
                          <b-form-group class="mb-2"  label="Название фабрики">
                            <b-form-input v-model.trim="product.factory_name" :class="{'is-invalid': errors.factory_name}"></b-form-input>
                            <div v-if="errors.factory_name" class="invalid-feedback">{{errors.factory_name[0]}}</div>
                          </b-form-group>

                          <b-form-group class="mb-3"  label="Адрес фабрики:">
                            <b-form-textarea id="short_description" v-model="product.factory_address" :class="{'is-invalid': errors.factory_address}">
                            </b-form-textarea>
                            <div v-if="errors.factory_address" class="invalid-feedback">{{errors.factory_address[0]}}</div>
                          </b-form-group>

                          <b-form-group class="mb-2"  label="Имя контакта">
                            <b-form-input v-model.trim="product.factory_contact_name" :class="{'is-invalid': errors.factory_contact_name}"></b-form-input>
                            <div v-if="errors.factory_contact_name" class="invalid-feedback">{{errors.factory_contact_name[0]}}</div>
                          </b-form-group>

                          <b-form-group class="mb-2"  label="Контакт">
                            <b-form-input v-model.trim="product.factory_contact" :class="{'is-invalid': errors.factory_contact}"></b-form-input>
                            <div v-if="errors.factory_contact" class="invalid-feedback">{{errors.factory_contact[0]}}</div>
                          </b-form-group>

                          <b-form-group class="mb-2"  label="Ссылка">
                            <b-form-input v-model.trim="product.factory_link" :class="{'is-invalid': errors.factory_link}"></b-form-input>
                            <div v-if="errors.factory_link" class="invalid-feedback">{{errors.factory_link[0]}}</div>
                          </b-form-group>

                        </b-card>

                        <div class="form-group row mb-0 mt-3">
                            <b-form-group class="col-lg-6 mb-2" description="Введите артикул товара" label="Артикул товара:">
                                <b-form-input v-model.trim="product.sku" :class="{'is-invalid': errors.sku}"></b-form-input>
                                <div v-if="errors.sku" class="invalid-feedback">{{errors.sku[0]}}</div>
                            </b-form-group>

                            <b-form-group class="col-lg-6 mb-2" description="Например: кг или шт." label="Еденица измерения:">
                                <b-form-input v-model.trim="product.unit_of_measure" :class="{'is-invalid': errors.unit_of_measure}"></b-form-input>
                                <div v-if="errors.unit_of_measure" class="invalid-feedback">{{errors.unit_of_measure[0]}}</div>
                            </b-form-group>
                        </div>

                        <div class="form-group row mb-0">

                          <b-form-group class="col-lg-3 mb-2" description="Введите вес товара, только числа" label="Вес единицы:">
                            <b-form-input v-model.number.trim="product.weight" :class="{'is-invalid': errors.unit_weight}"></b-form-input>
                            <div v-if="errors.unit_weight" class="invalid-feedback">{{errors.unit_weight[0]}}</div>
                          </b-form-group>

                          <b-form-group class="col-lg-3 mb-2" label="Вес общий:">
                            <b-form-input disabled :value="totalWeight(product.weight)" ></b-form-input>
                          </b-form-group>



                          <b-form-group class="col-lg-3 mb-2" description="Введите объём товара, только числа" label="Объём единицы:">
                            <b-form-input v-model.number.trim="product.volume" :class="{'is-invalid': errors.unit_volume}"></b-form-input>
                            <div v-if="errors.unit_volume" class="invalid-feedback">{{errors.unit_volume[0]}}</div>
                          </b-form-group>

                          <b-form-group class="col-lg-3 mb-2" label="Объём общий:">
                            <b-form-input disabled :value="totalVolume(product.volume)"></b-form-input>
                          </b-form-group>

                        </div>

                        <div class="form-group row mb-0">
                            <b-form-group class="col-lg-6 mb-2" description="Введите минимальное кол-во для заказа" label="Минимальный лот:">
                                <b-form-input v-model.number="product.minimum_lot" :class="{'is-invalid': errors.minimum_lot}"></b-form-input>
                                <div v-if="errors.minimum_lot" class="invalid-feedback">{{errors.minimum_lot[0]}}</div>
                            </b-form-group>
                        </div>

                        <h3 class="card-title mt-5 font-weight-bolder text-dark">Категории</h3>

                        <div class="categories-selected my-5">
                            <b-form-group
                                    v-slot="{ ariaDescribedby }"
                            >
                                <b-form-checkbox
                                        v-for="category in categories"
                                        v-model="category_ids"
                                        :key="category.id"
                                        :value="category.id"
                                        :aria-describedby="ariaDescribedby"
                                        name="flavour-3a"
                                >{{ category.name }}
                                    <b-form-checkbox
                                            v-for="sub_category in category.children_categories"
                                            v-model="sub_category_ids"
                                            :key="sub_category.id"
                                            :value="sub_category.id"
                                            :aria-describedby="ariaDescribedby"
                                            name="flavour-3a"
                                    >{{ sub_category.name }}
                                        <b-form-checkbox
                                                v-for="sub_sub_category in sub_category.children_categories"
                                                v-model="sub_sub_category_ids"
                                                :key="sub_sub_category.id"
                                                :value="sub_sub_category.id"
                                                :aria-describedby="ariaDescribedby"
                                                name="flavour-3a"
                                        >{{ sub_sub_category.name }}

                                        </b-form-checkbox>
                                    </b-form-checkbox>

                                </b-form-checkbox>
                            </b-form-group>
                        </div>

                        <div class="form-group row mb-0">

                            <b-form-group class="col-lg-6 mb-2" description="Назначьте тип товара. Товар на складе или для заказа" label="Тип товара:">
                                <b-form-select v-model="product.type" :class="{'is-invalid': errors.type}">
                                    <option value="for_order">Для заказа</option>
                                    <option value="in_stock">В наличии</option>
                                </b-form-select>
                                <div v-if="errors.type" class="invalid-feedback">{{errors.type[0]}}</div>
                            </b-form-group>

                            <b-form-group v-if="product.type === 'in_stock'" class="col-lg-6 mb-2" description="Количество на складе" label="Количество:">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <button v-b-tooltip.hover title="Посчитать количество товара исходя из количества всех вариантов" @click="getStock" class="btn btn-primary" type="button">Пересчитать</button>
                                    </div>
                                    <b-form-input v-model="product.stock" :class="{'is-invalid': errors.stock}"></b-form-input>
                                </div>
                                <div v-if="errors.stock" class="invalid-feedback">{{errors.stock[0]}}</div>
                            </b-form-group>

                        </div>




                        <div class="form-group row mb-0">
                            <b-form-group class="col-lg-12 mb-2" label="Новый товар:">
                                <b-form-checkbox size="lg" v-model="product.new" value="1" unchecked-value="0">
                                    Включить иконку нового товара
                                </b-form-checkbox>
                            </b-form-group>
                        </div>



                        <hr>

                        <div class="card card-custom card-stretch gutter-b">
                            <!--begin::Header-->
                            <div class="card-header border-0 py-5">
                                <h3 class="card-title align-items-start flex-column">
                                    <span class="card-label font-weight-bolder text-dark">Цена</span>
                                    <span class="text-muted mt-3 font-weight-bold font-size-sm">
                                        Формирование цены от города и срока доставки
                                    </span>
                                </h3>
                            </div>
                            <!--end::Header-->
                            <div class="card-body pt-0 pb-3">
                                <div class="align-items-center mb-10">

                                    <div class="form-group row mb-0">
                                    <b-form-group class="col-lg-12 mb-2" label="Скидка:">
                                            <b-form-checkbox size="lg" v-model.number="product.sale" :value="1" :unchecked-value="0">
                                                Включить скидку на товар
                                            </b-form-checkbox>
                                    </b-form-group>
                                    </div>

                                        <div class="form-group row mb-0">

                                            <b-form-group class="col-lg-3 mb-2" :description=" 'По курсу: ' + settings.dollar_rate + ' р за доллар'" label="Закупочная цена за единицу:">
                                                <div class="input-group">
                                                    <div class="input-group-prepend"><span class="input-group-text"><i class="fas fa-dollar-sign icon-lg"></i></span></div>
                                                    <b-form-input v-model.number="product.price" :class="{'is-invalid': errors.price}"></b-form-input>
                                                    <div v-if="errors.price" class="invalid-feedback">{{errors.price[0]}}</div>
                                                </div>
                                            </b-form-group>

                                          <b-form-group class="col-lg-3 mb-2" description="Цена в рублях" label="Закупочная цена за единицу:">
                                            <div class="input-group">
                                              <div class="input-group-prepend"><span class="input-group-text"><i class="fas fa-ruble-sign icon-lg"></i></span></div>
                                              <b-form-input :value="priceConverter(product.price)" disabled></b-form-input>
                                            </div>
                                          </b-form-group>


                                          <template v-if="product.sale">
                                            <b-form-group class="col-lg-3 mb-2" description="Введите скидку" label="Скидка в процентах:">
                                              <b-form-input v-model.number="product.discount" :class="{'is-invalid': errors.discount}" required></b-form-input>
                                              <div v-if="errors.discount" class="invalid-feedback">{{errors.discount[0]}}</div>
                                            </b-form-group>
                                            <b-form-group class="col-lg-3 mb-2" description="В рублях" label="Сумма со скидкой:">
                                              <b-form-input :value="saleConverter(priceConverter(product.price))" disabled></b-form-input>
                                            </b-form-group>
                                          </template>




                                        </div>


                                        <div class="row align-items-center mt-3">
                                            <div class="col-md-4 my-2 my-md-0">
                                                <b-form-select
                                                        class="mb-2 mr-sm-2 mb-sm-0"
                                                        :value="null"
                                                        v-model="add_city"
                                                        :class="{'is-invalid': errorsAddCity}"
                                                >
                                                    <option :value="null">Выберите город</option>
                                                    <option value="all">Добавить все города</option>
                                                    <template v-for="(city, i) in cities" >
                                                        <option v-bind:key="i"
                                                                :value="city"
                                                                :disabled="disabledCity(city.id)"
                                                        >{{city.name}}</option>
                                                    </template>
                                                </b-form-select>
                                            </div>
                                            <div class="col-md-4 my-2 my-md-0">
                                                <b-button @click="addCityToProduct" ref="add_attribute_product" variant="primary">Добавить город(а)</b-button>
                                            </div>
                                        </div>
                                </div>

                                <draggable :list="product.cities" v-bind="{animation:400}" :tag="'div'" handle=".hand">
                                    <template v-for="city in product.cities" >
                                        <div class="card card-custom card-stretch gutter-b" style="border: solid 1px #000">

                                            <div class="card-body px-4 pt-4 pb-4">

                                            <div class="mb-3">
                                              <h3>{{ city.name }}</h3>
                                            </div>

                                            <div class="table-responsive">
                                                <table class="table table-head-custom table-head-bg table-borderless table-vertical-center">
                                                    <thead>
                                                    <tr class="text-uppercase">
                                                      <th>Метод</th>
                                                      <th>Кол-во дней</th>
                                                      <th>Логистика КНР (В долларах)</th>
                                                      <th>Логистика КНРРФ (В долларах)</th>
                                                      <th>ТП (В долларах)</th>
                                                      <th>Логистика РФ (В долларах)</th>
                                                      <th>Логистика</th>
                                                      <th>Итоговая цена за лот</th>
                                                      <th>цена по умолчанию</th>

                                                    </tr>
                                                    </thead>
                                                    <tr v-for="method in city.methods">
                                                      <td style="padding-left: 0">
                                                        <b-form-input disabled v-model.trim="method.name"></b-form-input>
                                                      </td>
                                                      <td>
                                                        <b-form-input v-model.number="method.days"></b-form-input>
                                                      </td>
                                                      <td>
                                                        <b-form-input v-model.number="method.knr"></b-form-input>
                                                      </td>
                                                      <td>
                                                        <b-form-input v-model.number="method.knrrf"></b-form-input>
                                                      </td>
                                                      <td>
                                                        <b-form-input v-model.number="method.tp"></b-form-input>
                                                      </td>
                                                      <td>
                                                        <b-form-input v-model.number="method.rf"></b-form-input>
                                                      </td>

                                                      <td>
                                                        <b-form-input disabled :value="totalLogistics(method) + ' р.'"></b-form-input>
                                                      </td>

                                                      <td style="padding-right: 0">
                                                        <b-form-input disabled :value="totalPricePerLot(method) + ' р.'"></b-form-input>
                                                      </td>

                                                      <td style="padding-right: 0; text-align: center">
                                                        <b-form-checkbox size="lg"
                                                                         v-model="method.default"
                                                                         :value="true"
                                                                         :unchecked-value="false">
                                                        </b-form-checkbox>
                                                      </td>

                                                    </tr>
                                                </table>
                                            </div>


                                              <div class="col-md-12 my-2 my-md-0" style="text-align: right;">
                                                <b-button style="cursor: move;" size="sm" class="mr-2 hand"><i class="fas fa-arrows-alt-v"></i> Изменить порядок</b-button>
                                                <b-button @click="showDeleteCityModal(city)" size="sm" variant="danger">Удалить город</b-button>
                                              </div>


                                            </div>
                                        </div>
                                    </template>

                                </draggable>
                            </div>
                        </div>

                        <hr>

                        <div class="card card-custom card-stretch gutter-b">
                            <!--begin::Header-->
                            <div class="card-header border-0 py-5">
                                <h3 class="card-title align-items-start flex-column">
                                    <span class="card-label font-weight-bolder text-dark">Атрибуты</span>
                                    <span class="text-muted mt-3 font-weight-bold font-size-sm">
                    Атрибуты позволяют определять дополнительные сведения о товаре, такие как размер, цвет и тд. Также из атрибутов создаются вариации товаров</span>
                                </h3>
                            </div>
                            <!--end::Header-->
                            <div class="card-body pt-0 pb-3">
                                <div class="row align-items-center mb-10">
                                    <div class="col-lg-12 col-xl-12">
                                        <div class="row align-items-center">
                                            <div class="col-md-4 my-2 my-md-0">
                                                <b-form-select
                                                        class="mb-2 mr-sm-2 mb-sm-0"
                                                        :value="null"
                                                        v-model="add_attribute"
                                                        :class="{'is-invalid': errorsAddAttribute}"
                                                >
                                                    <option :value="null">Выберите атрибут</option>
                                                    <option value="new">Новый атрибут</option>
                                                    <template v-for="(attribute, i) in attributes" >
                                                        <option v-bind:key="i"
                                                                :value="attribute"
                                                                :disabled="disabledAttributes(attribute.id)"
                                                        >{{attribute.name}}</option>
                                                    </template>
                                                </b-form-select>
                                            </div>
                                            <div class="col-md-4 my-2 my-md-0">
                                                <b-button @click="addAttributeToProduct" ref="add_attribute_product" variant="primary">Добавить атрибут</b-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <draggable :list="product.attributes" v-bind="{animation:400}" :tag="'div'" handle=".hand" @change="updateSortAttribute">

                                    <template v-for="attribute in product.attributes" >
                                        <AttributeInProduct
                                                :attribute="attribute"
                                                @delete_attribute="deleteAttribute"
                                                @save_attribute="saveAttribute"
                                        />
                                    </template>
                                </draggable>
                            </div>
                        </div>
                        <hr>
                        <VariationsProduct
                                :product="product"
                                @add_variation="addVariation"
                                @update_variation="updateVariation"
                                @delete_variation="deleteVariation"
                        />

                        <hr>
                        <h3 class="card-title mt-10 font-weight-bolder text-dark">Описание товара</h3>


                        <b-form-group class="mt-3"
                                      description="Введите краткое описание"
                                      label="Краткое описание:"

                        >
                            <b-form-textarea
                                    id="short_description"
                                    v-model="product.short_description"
                                    :class="{'is-invalid': errors.short_description}"
                            ></b-form-textarea>
                            <div v-if="errors.short_description" class="invalid-feedback">{{errors.short_description[0]}}</div>
                        </b-form-group>


                        <b-form-group class="mt-3"
                                      label="Подробное описание"
                        >

                            <!--TODO: исправить ошибку: Error in callback for watcher "value": "TypeError: Cannot read property 'setData' of null"-->

                            <ckeditor :editor="editor" v-model="product.description" :config="editorConfig"></ckeditor>
                            <div v-if="errors.description" style="display: block;" class="invalid-feedback">{{errors.description[0]}}</div>
                        </b-form-group>

                        <h3 class="card-title mt-10 font-weight-bolder text-dark">Мета теги</h3>

                        <b-form-group class="mt-0" description="Введите тег заголовок" label="Заголовок:">
                            <b-form-input v-model.trim="product.meta_title" placeholder="Введите тег Заголовок"></b-form-input>
                        </b-form-group>



                        <b-form-group class="mt-0" description="Введите тег Description" label="Description:">
                            <b-form-textarea placeholder="Введите тег Description" v-model.trim="product.meta_description"></b-form-textarea>
                        </b-form-group>


                        <b-button v-if="action() === 'add'" @click="addProduct" ref="add_product" type="submit" variant="primary">Создать товар</b-button>

                        <div v-if="action() === 'edit'" class="d-flex justify-content-between">
                            <b-button @click="saveProduct" ref="add_product" type="submit" variant="primary">Сохранить товар</b-button>
                            <b-button @click="showModal" ref="del_product" type="submit" variant="outline-danger">Удалить товар</b-button>
                        </div>



                    </div>
                </div>
            </div>
        </div>

        <b-modal ref="add-attribute-modal" centered hide-footer title="Добавить новый атрибут">
            <div class="d-block">

                <div role="alert" class="alert alert-info alert-dismissible text-white text-center">
                    <strong><i class="fa fa-info-circle"></i> Внимание!</strong>
                    <br>Вы добавляете новый атрибут в общий список атрибутов вашего сайта и привязываете его к этому товару.
                </div>

                <div class="form-group mb-1">
                    <label>Название атрибута</label>
                    <input v-model.trim="newAttribute.name"
                           type="text"
                           class="form-control"
                           :class="{'is-invalid': errorsAttributes.name}"
                           maxlength="50"
                           placeholder="Введите название атрибута"
                           value="">
                    <div v-if="errorsAttributes.name" class="invalid-feedback">{{errorsAttributes.name[0]}}</div>
                    <small>Например: Цвет</small>
                </div>

                <b-form-group class=" mb-2"
                              description="Выберите вид опций для вариативных товаров"
                              label="Тип опций"
                >
                    <b-form-select v-model="newAttribute.type" :class="{'is-invalid': errorsAttributes.type}">

                        <option value="default">По умолчанию</option>
                        <option value="color">Цвет</option>


                    </b-form-select>
                    <div v-if="errorsAttributes.type" class="invalid-feedback">{{errorsAttributes.type[0]}}</div>
                </b-form-group>

            </div>

            <b-button @click="addAttribute" block ref="add_new_attribute" type="submit" variant="primary">Создать</b-button>


        </b-modal>


        <b-modal ref="delete-modal" centered hide-footer hide-header title="Подтвердите действие">
            <div class="d-block text-center">
                <h3>Удалить товар: {{product.title}}?</h3>
            </div>
            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" block @click="hideModal">Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button class="mt-3" variant="outline-danger" block @click="deleteProduct()">Удалить</b-button>
                </b-col>
            </b-row>
        </b-modal>

         <b-modal ref="delete-modal-city" centered hide-footer hide-header title="Подтвердите действие">
            <div class="d-block text-center">
                <h3>Удалить город: {{deleteCity.name}}?</h3>
            </div>
            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" block @click="hideDeleteCityModal">Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button class="mt-3" variant="outline-danger" block @click="deleteCityMethod">Удалить</b-button>
                </b-col>
            </b-row>
        </b-modal>


    </div>
</template>

<script>


    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import "@ckeditor/ckeditor5-build-classic/build/translations/ru"
    import {
        GET_TRANSLATE,
        GET_PRODUCT,
        UPDATE_PRODUCT,
        DELETE_PRODUCT,
        NEW_PRODUCT,
        ADD_PRODUCT,
        SET_PRODUCTS_ERROR
    } from "@/core/services/store/products.module";
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import draggable from 'vuedraggable';
    import {GET_SELECT} from "@/core/services/store/categories.module";
    import {SET_ALERT} from "@/core/services/store/alert.module";
    import {
        ADD_ATTRIBUTE,
        ATTACH_ATTRIBUTE_TO_PRODUCT,
        GET_ATTRIBUTES, SORT_ATTRIBUTE_TO_PRODUCT
    } from "../../../core/services/store/attributes.module";
    import AttributeInProduct from "./components/AttributeInProduct";
    import VariationsProduct from "./components/VariationsProduct";
    import UploadAdapter from "../../../uploadadapter";
    import {GET_CITIES} from "../../../core/services/store/cities.module";
    import {GET_SETTINGS} from "../../../core/services/store/settings.module";
    export default {
        name: "EditProduct",
        components: {
            VariationsProduct,
            AttributeInProduct,
            vueDropzone: vue2Dropzone, draggable
        },

        mounted() {
            if (this.action() === 'edit'){
                this.getProduct();

                this.$store.dispatch(SET_BREADCRUMB, [
                    { title: "Товары", route: "/products" },
                    { title: "Редактирование товара" }
                ]);
            } else if (this.action() === 'add'){
                this.$store.commit(NEW_PRODUCT);
                this.$store.dispatch(SET_BREADCRUMB, [
                    { title: "Товары", route: "/products" },
                    { title: "Добавить товар" }
                ]);
            }



            this.getSettingsSite();
            this.getCities();
            this.$store.commit(SET_PRODUCTS_ERROR, {});
            this.$store.dispatch(GET_SELECT);
            this.$store.dispatch(GET_ATTRIBUTES);
        },

        computed: {
            ...mapGetters({
              load: 'getProductLoad',
              product: 'gettersProduct',
              errors: 'errorsProducts',
              code: 'getProductCode',
              categories: 'getSelectCategory',
              attributes: 'gettersAttributes',
              cities: 'gettersCities',
              settings: 'gettersSettingSite',
              errorsAttributes: 'errorsAttribute',
            }),

        },

        data(){
            return{

                add_attribute: null,
                errorsAddAttribute: false,

                add_city: null,
                errorsAddCity: false,

                category_ids: [],
                sub_category_ids: [],
                sub_sub_category_ids: [],

                deleteCity: {
                    id: null,
                    name: ''
                },

                newAttribute: {
                    name: '',
                    type: 'default'
                },

                editor: ClassicEditor,
                editorConfig: {
                    extraPlugins: [this.uploader],
                    language: "ru"
                },

                dropzoneOptions: {
                    url: this.$urlBackEnd('/api/v1/product/images'),
                    acceptedFiles: '.jpg, .jpeg, .png,',
                    thumbnailWidth: 200,
                    maxFilesize: 8,
                    maxFiles:50,
                    headers: { "Authorization": 'Bearer ' + localStorage.getItem('id_token') },
                    parallelUploads: 1,
                    createImageThumbnails: true,
                    uploadMultiple: false,
                },

            }
        },

        methods:{


          totalWeight(weight){

            let sum = weight * this.product.minimum_lot

            if (Number.isNaN(sum)){
              return 'Введите только числа'
            } else {
              return +sum.toFixed(2)
            }

          },

          totalVolume(volume){

            let sum = volume * this.product.minimum_lot

            if (Number.isNaN(sum)){
              return 'Введите только числа'
            } else {
              return +sum.toFixed(2)
            }

          },

          priceConverter(price){
            let sum = price * this.settings.dollar_rate

            if (Number.isNaN(sum)){
              return 'Введите только числа'
            } else {
              return +sum.toFixed(2)
            }
          },

          saleConverter(price){

            let sum = price - ( price * this.product.discount / 100)

            if (Number.isNaN(sum)){
              return 'Введите только числа'
            } else {
              return +sum.toFixed(2)
            }

          },


          totalLogistics(method){

            let knr = method.knr ? method.knr : 0;
            let knrrf = method.knrrf ? method.knrrf : 0;
            let rf = method.rf ? method.rf : 0;
            let tp = method.tp ? method.tp : 0;
            let sum = (knr + knrrf + rf + tp) * this.totalWeight(this.product.weight)
            return this.priceConverter(sum)
          },


          totalPricePerLot(method){

            let knr = method.knr ? method.knr : 0;
            let knrrf = method.knrrf ? method.knrrf : 0;
            let rf = method.rf ? method.rf : 0;
            let tp = method.tp ? method.tp : 0;

            let sum = (knr + knrrf + rf + tp) * this.totalWeight(this.product.weight)
            if (this.product.sale){
              let sale = this.saleConverter(this.product.price * this.product.minimum_lot) + sum
              return this.priceConverter(sale)
            } else {
              return this.priceConverter(sum + (this.product.price * this.product.minimum_lot))
            }
          },

            async getProduct(){

                try {
                    await this.$store.dispatch(GET_PRODUCT, this.$route.params.id);
                    this.getCategoryIds();
                    this.getSubCategoryIds();
                    this.getSubSubCategoryIds();
                } catch (e) {

                    this.showAlert('Ошибка загрузки товара', 'danger', 'toast');
                }

            },

            getCategoryIds(){
                this.category_ids = [];
                if (this.product.categories.length > 0){
                    this.product.categories.forEach( category => {
                        this.category_ids.push(category.id);
                    })
                } else {
                    this.category_ids = []
                }
            },

            getSubCategoryIds(){
                this.sub_category_ids = [];
                if (this.product.sub_categories.length > 0){
                    this.product.sub_categories.forEach( category => {
                        this.sub_category_ids.push(category.id);
                    })
                } else {
                    this.sub_category_ids = []
                }
            },

            getSubSubCategoryIds(){
                this.sub_sub_category_ids = [];
                if (this.product.sub_sub_categories.length > 0){
                    this.product.sub_sub_categories.forEach( category => {
                        this.sub_sub_category_ids.push(category.id);
                    })
                } else {
                    this.sub_sub_category_ids = []
                }
            },

            action(){
                return this.$route.params.action
            },

            uploader(editor)
            {
                editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                    return new UploadAdapter( loader );
                };
            },

            async getCities(){
                try {
                    await this.$store.dispatch(GET_CITIES, {'page': this.$route.params.page, 'filter': {to: '100'}});
                } catch (e) {
                    this.showAlert('Ошибка загрузки городов', 'danger', 'toast');
                }
            },


          async getSettingsSite(){
              try {
                await this.$store.dispatch(GET_SETTINGS);
              } catch (e){
                this.showAlert('Ошибка загрузки настроек сайта', 'danger', 'toast');
              }
          },


            getCode(){
                const titlecode = {
                    'title': this.product.title
                };

                const submitButtonUrl = this.$refs["get_product_url"];
                submitButtonUrl.classList.add("spinner", "spinner-light", "spinner-right");

                this.$store.dispatch(GET_TRANSLATE, titlecode)
                    .then(() => {
                        this.product.code = this.code
                        this.showAlert('URL адрес успешно сформирован ', 'success', 'toast');
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Введите название товара', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        submitButtonUrl.classList.remove("spinner", "spinner-light", "spinner-right")
                    });
            },

            getStock(){

                if (this.product.variants.length > 0){
                    var st = 0;
                    this.product.variants.forEach(function (variant) {
                        st = Number(st) + Number(variant.stock);
                    });
                    this.product.stock = st;
                    this.showAlert('Количество товара пересчитано ', 'success', 'toast');
                } else {
                    this.showAlert('В этом товаре нет вариантов', 'warning', 'toast');
                }
            },

            successDrop (file, response) {
                this.$refs.myVueDropzone.removeFile(file);

                const img = {
                    image_id: response.id,
                    src: response.original,
                    thumbnail: response.thumbnail,
                };

                this.product.images.push(img);
            },

            maxDrop (){

            },

            removeImage(id){
                var indexToRemove = this.product.images.findIndex(obj => obj.image_id == id);
                this.product.images.splice(indexToRemove , 1);
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

            saveProduct(){

                const submitButton = this.$refs["add_product"];
                submitButton.classList.add("spinner", "spinner-light", "spinner-right");

                this.product.categories = this.category_ids;
                this.product.sub_categories = this.sub_category_ids;
                this.product.sub_sub_categories = this.sub_sub_category_ids;

                this.$store.dispatch(UPDATE_PRODUCT, {'id': this.product.id, "product": this.product})
                    .then(() => {
                        this.showAlert('Товар успешно сохранен', 'success');
                        this.$router.push({ name: "Products" })
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
                    });
            },

            addProduct(){

                const submitButton = this.$refs["add_product"];
                submitButton.classList.add("spinner", "spinner-light", "spinner-right");

                this.product.categories = this.category_ids;

                this.$store.dispatch(ADD_PRODUCT, this.product)
                    .then(() => {
                        this.showAlert('Товар: ' + this.product.title + ' успешно создан', 'success');
                        this.$router.push({ name: "Products" })
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
                    });

            },


            showModal() {
                this.$refs['delete-modal'].show()
            },

            hideModal() {
                this.$refs['delete-modal'].hide()
            },

            showDeleteCityModal(city){
                this.deleteCity = {
                    id: city.id,
                    name: city.name,
                };
                this.$refs['delete-modal-city'].show()
            },

            hideDeleteCityModal(){
                this.$refs['delete-modal-city'].hide()
            },

            deleteCityMethod(){
                const indexToRemove = this.product.cities.findIndex(obj => obj.id === this.deleteCity.id);
                this.product.cities.splice(indexToRemove , 1);
                this.hideDeleteCityModal()
            },

            deleteProduct(){
                this.$store.dispatch(DELETE_PRODUCT, this.product.id)
                    .then(() => {
                        this.showAlert('Товар успешно удален (перемещен в архив)', 'success');
                        this.$router.push({ name: "Products" })
                    })
                    .catch(() => {
                        this.showAlert('Ошибка удаления', 'danger', 'toast');
                    })
                    .finally(() => {
                        this.hideModal()
                    })
            },

            addAttributeToProduct(){
                if (this.add_attribute && this.add_attribute !== 'null'){
                    this.errorsAddAttribute = false;
                    if (this.add_attribute === 'new'){
                        this.$refs['add-attribute-modal'].show()
                    } else {
                        if (!this.product.attributes.find(obj => obj.attribute.id === this.add_attribute.id)) {

                            if (this.action() === 'edit'){
                                const submitAddAttributeButton = this.$refs["add_attribute_product"];
                                submitAddAttributeButton.classList.add("spinner", "spinner-light", "spinner-right");

                                this.$store.dispatch(ATTACH_ATTRIBUTE_TO_PRODUCT, {
                                    product: this.product.id,
                                    attribute: this.add_attribute.id
                                })
                                    .then((data) => {
                                        this.product.attributes.push(data.attribute);
                                        this.add_attribute = null
                                        this.showAlert('Атрибут успешно добавлен ', 'success', 'toast');
                                    })
                                    .catch(() => {
                                        this.showAlert('Ошибка. Попробуйте позже', 'danger', 'toast');
                                    })
                                    .finally(() => {
                                        submitAddAttributeButton.classList.remove("spinner", "spinner-light", "spinner-right")
                                    })

                            } else if (this.action() === 'add'){
                                const new_attribute = {
                                    attribute_id: this.add_attribute.id,
                                    attribute: this.add_attribute,
                                    options: [],
                                    sort: this.product.attributes.length > 0 ? this.product.attributes.length + 1 : 1,
                                    image: 0,
                                    image_type:"variant",
                                    images:[]
                                };

                                this.product.attributes.push(new_attribute);
                                this.add_attribute = null
                                this.showAlert('Атрибут успешно добавлен ', 'success', 'toast');
                            }
                        } else {
                            this.showAlert('Ошибка! Такой атрибут уже добавлен', 'danger', 'toast');
                        }
                    }
                } else {
                    this.errorsAddAttribute = true;
                    this.showAlert('Необходимо выбрать атрибут', 'warning', 'toast');
                }
            },

            addCityToProduct(){
                if (this.add_city && this.add_city !== 'null') {
                    this.errorsAddCity = false;
                    if (this.add_city === 'all'){

                        let addCities = 0;

                        this.cities.forEach( city => {
                            if (!this.product.cities.find(obj => obj.id === city.id)) {
                                this.product.cities.push(city);
                                addCities++
                            }
                        });

                        if (addCities > 0){
                            this.showAlert(`Добавленное кол-во городов: ${addCities}`, 'success', 'toast');
                            this.add_city = null
                        } else {
                            this.showAlert('Ошибка! Такие города уже добавлены', 'danger', 'toast');
                            this.add_city = null
                        }

                    } else {
                        this.product.cities.push(this.add_city);
                        this.add_city = null;
                    }

                } else {
                    this.errorsAddCity = true;
                    this.showAlert('Необходимо выбрать город', 'warning', 'toast');
                }
            },

            addAttribute(){
                const submitAddNewAttribute = this.$refs["add_new_attribute"];
                submitAddNewAttribute.classList.add("spinner", "spinner-light", "spinner-right");

                this.$store.dispatch(ADD_ATTRIBUTE, this.newAttribute)
                    .then((data) => {
                        this.$store.dispatch(GET_ATTRIBUTES)
                            .then(() => {

                                if (this.action() === 'edit'){
                                    this.$store.dispatch(ATTACH_ATTRIBUTE_TO_PRODUCT, {product: this.product.id, attribute: data.newattribute.id})
                                        .then((data) => {
                                            this.product.attributes.push(data.attribute);
                                            this.add_attribute = null;
                                            this.showAlert('Атрибут успешно добавлен ', 'success', 'toast');
                                            this.newAttribute = {name: '', type: 'default'};
                                        })
                                        .catch((response) => {
                                            this.showAlert('Ошибка. Попробуйте позже. Код ошибки: ' + response.status, 'danger', 'toast');
                                        })
                                        .finally(() => {
                                            submitAddNewAttribute.classList.remove("spinner", "spinner-light", "spinner-right")
                                            this.$refs['add-attribute-modal'].hide();
                                        });
                                } else if (this.action() === 'add'){
                                    const new_attribute = {
                                        attribute_id: data.newattribute.id,
                                        attribute: data.newattribute,
                                        options: [],
                                        sort: this.product.attributes.length > 0 ? this.product.attributes.length + 1 : 1,
                                        image: 0,
                                        image_type:"variant",
                                        images:[]
                                    };
                                    this.$set(new_attribute.attribute, 'options', []);
                                    this.product.attributes.push(new_attribute);
                                    this.add_attribute = null;
                                    this.showAlert('Атрибут успешно добавлен ', 'success', 'toast');
                                    this.newAttribute = {name: '', type: 'default'};
                                }

                            });
                    })
                    .catch((response) => {
                        submitAddNewAttribute.classList.remove("spinner", "spinner-light", "spinner-right");
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже. Код ошибки: ' + response.status, 'danger', 'toast');
                        }
                    })
            },

            disabledAttributes(id){
                if (this.product.attributes){
                    if (this.product.attributes.find(obj => obj.attribute.id === id)){
                        return true
                    }
                }
            },

            disabledCity(id){

                if (this.product.cities){
                    if (this.product.cities.find(obj => obj.id === id)){
                        return true
                    }
                }
            },

            deleteAttribute(id){
                var indexToAttributes = this.product.attributes.findIndex(obj => obj.id === id);
                this.product.attributes.splice(indexToAttributes , 1);
                this.product.attributes.map((attributes, index) => {
                    attributes.sort = index + 1;
                });

                if (this.action() === 'edit'){
                    this.updateSortAttribute()
                }
            },


            saveAttribute(attribute){
                // var indexToSave = this.product.attributes.findIndex(obj => obj.attribute_id === attribute.attribute_id);
                const indexToSave = this.product.attributes.findIndex(obj => obj.id === attribute.id);
                this.product.attributes.splice(indexToSave , 1, attribute);
            },

            addVariation(variation){
                this.product.variants.push(variation)
            },

            updateVariation(variation){
                const indexToSave = this.product.variants.findIndex(obj => obj.id === variation.id);
                this.product.variants.splice(indexToSave, 1, variation);
            },

            deleteVariation(id){
                const indexToDelete = this.product.variants.findIndex(obj => obj.id === id);
                this.product.variants.splice(indexToDelete, 1);
            },


            updateSortAttribute(){

                this.product.attributes.map((attributes, index) => {
                    attributes.sort = index + 1;
                });


                if (this.action() === 'edit'){
                    this.$store.dispatch(SORT_ATTRIBUTE_TO_PRODUCT, {product: this.product.id, attributes: this.product.attributes})
                        .then(() => {
                            this.showAlert('Сортировка атрибутов сохранена', 'success', 'toast');
                        })
                        .catch(() => {
                            this.showAlert('Ошибка, проверьте соединение с интернетом', 'danger', 'toast');
                        })
                }

            },

            numberWithSpaces(x){
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            },

            updateTotalPricePerLot(item){
                let sum = Number(item.totalUnitPrice) * Number(this.product.minimum_lot);
                item.totalPricePerLot = +sum.toFixed(2)
            }

        },

        watch: {

            '$route.params.action': {
                immediate: true,
                handler() {
                    if (this.action() === 'add'){
                        this.$store.commit(NEW_PRODUCT);
                        this.$store.dispatch(SET_BREADCRUMB, [
                            { title: "Товары", route: "/products" },
                            { title: "Добавить товар" }
                        ]);
                    }

                },
            },

            /*'$route.params.id': {
                immediate: true,
                handler() {
                    if (this.action() === 'edit'){
                        this.$store.dispatch(GET_PRODUCT, this.$route.params.id);

                        this.$store.dispatch(SET_BREADCRUMB, [
                            { title: "Товары", route: "/products" },
                            { title: "Редактирование товара" }
                        ]);

                    }

                },
            },*/

            '$route.params.id': function () {
                if (this.action() === 'edit'){
                    this.getProduct();
                    this.$store.dispatch(SET_BREADCRUMB, [
                        { title: "Товары", route: "/products" },
                        { title: "Редактирование товара" }
                    ]);
                }
            }

        },
    }
</script>

<style scoped>

    .ui-sortable .image{
        max-width: 150px;
        float: left;
        cursor: move;
        border: 1px solid #d5d5d5;
        margin: 9px 9px 0 0;
        background: #f7f7f7;
        border-radius: 2px;
        position: relative;
        box-sizing: border-box;
    }

    .ui-sortable {
        list-style: none;
        overflow:hidden
    }

    .ui-sortable i {
        cursor: pointer;
        position: absolute;
        background: red;
        padding: 6px;
        z-index: 5;
        color: #ffffff;
        font-size: 12px;
        border-radius: 5px;
        top: -4px;
        right: -4px;
    }

    .categories-selected{
        overflow: auto;
        height: 500px;
        background: #f6f6f6;
        padding: 15px;
    }

</style>